@if (!loading) {
<div class="box">
  <div class="table-toolbar">
    <mat-form-field class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search channels…" />
    </mat-form-field>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" class="full-width-table" matSort>

      <ng-container matColumnDef="channel_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Channel Name</th>
        <td mat-cell *matCellDef="let element">{{ element.channel_name }}</td>
      </ng-container>

      <ng-container matColumnDef="Description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let element">{{ element.Description }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button class="action-btn" title="Edit"
                  (click)="openModal(applicationName, element, 'Edit', true); $event.stopPropagation()">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr *matNoDataRow>
        <td colspan="3">
          <div class="empty-state">
            <mat-icon>cell_tower</mat-icon>
            <p>No channels found</p>
          </div>
        </td>
      </tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
          class="table-row" (click)="openModal(applicationName, row, 'Edit', true)"></tr>
    </table>
  </div>

  <mat-paginator [showFirstLastButtons]="true" [pageSizeOptions]="[5, 10, 25]"
    aria-label="Select page">
  </mat-paginator>
</div>
}

@if (loading) {
  <app-loading-spinner></app-loading-spinner>
}
